import {RegexConstants} from "../constants";

export const getDispositionFileName = (res: Response) => {
  const disposition = res.headers.get('Content-Disposition');
  if (disposition) {
    const matches = RegexConstants.ContentDispositionFileName.exec(disposition);
    if (matches !== null) {
      return matches[2];
    }
  }
  return null;
}

export const downloadFileFromHttpResponse = async (res: Response, name: string) => {
  let fileName = name;
  const dispositionFileName = getDispositionFileName(res);
  if (dispositionFileName) {
    fileName = decodeURIComponent(dispositionFileName);
  }
  const blob = await res.blob();
  fileDownloader(blob, fileName);
};

export const fileDownloader = (blob: Blob, name: string) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', name);
  document.body.appendChild(link);
  link.click();
  // clean up element
  link.parentNode?.removeChild(link);
  // clean up Url
  window.URL.revokeObjectURL(blobUrl);
};